import form from '@wwdev/forms';
import Zipcode from '@wwdev/zipcode';

form.init('form');
Zipcode.init();

const FormConfig = {
	scope: '[data-zipcode="scope"]',
	zipcodeSelector: '[name="postcode-huisnummer-5[0]"]',
	streetSelector: '[name="adres-6[0]"]',
	streetNumberSelector: '[name="postcode-huisnummer-5[1]"]',
	townSelector: '[name="adres-6[1]"]',
	countrySelector: '[data-scope="country"]',
};
Zipcode.init(FormConfig);